/*save image on disc mixin*/

// libraries
import html2canvas from 'html2canvas';

export default {
  methods: {
    getImage(canvasPictureImg) {
      const image = new Image();
      image.src = canvasPictureImg;

      return image;
    },
    setDataImage(canvas) {
      return canvas.toDataURL('saveImage/png');
    },
    saveToImage(canvas) {
      const canvasPictureImg = this.setDataImage(canvas);
      const image = this.getImage(canvasPictureImg);
      const link = document.getElementById(`download${this.chartId}`);

      link.setAttribute("href", image.src);
      link.setAttribute("download", `${this.title} ${this.chartDate}`);
      link.click();
    },
    onSave(value) {
      if (value) {
        this.$emit("onSaveChart", this.chartName);

        const chart = document.getElementById(this.chartId);
        let hiddenTitle = chart.querySelector(`.hidden-chart-name`);
        hiddenTitle.classList.add('hidden-chart-name--visible');

        html2canvas(chart, {
          allowTaint: true,
          logging: false,
          taintTest: false,
          scale: 2
        }).then((canvas) => {
          try {
            this.saveToImage(canvas);
            hiddenTitle.classList.remove('hidden-chart-name--visible');
            this.$emit("onSavedChart", this.chartName);
          } catch (error) {
            console.error('picture save error: ', error);
          }
        });
      }
    }
  },
  watch: {
    saveChart(value) {
      this.onSave(value)
    }
  },
};
